import React, { Component } from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
//components
import ReportsPage from "./MonthParts/ReportsPage";
import ReportsSideNav from "./MonthParts/ReportsSideNav";
import Loader from "../LoaderNew/Loader";
//funcs
import {
  getReport,
  generateReport,
  isExistReport,
} from "../../functions/api/orders";
import SideBar from "../SideBar/SideBar";
import * as actions from "../../actions/actions";
import { FULL_VIEW_ONLY, DEPARTMENT_ONLY, TASK_REMARK_ONLY, TASK_REMARK_QUANTITY_ONLY, ALL_FINANCIALS } from "../../tools/keys/variables";

class MonthlyReports extends Component {
  constructor() {
    super();
    this.state = {
      startingDate: moment().startOf("month"),
      endingDate: moment().endOf("month"),
      timestamp: {
        from: moment().startOf("month"),
        to: moment().endOf("month"),
      },
      dataArray: [],
      loader: false,
      isGenerated: false,
      csvData: [],
      changeToNewDates: true,
      total_actual: 0,
      total_planned: 0
    };
  }

  async componentDidMount() {
    this.generateReport();
  }

  generateReport = async () => {
    let startingDate = moment(this.state.timestamp.from).format("DD/MM/YYYY");
    let endingDate = moment(this.state.timestamp.to).format("DD/MM/YYYY");
    this.setState({ isGenerated: false })
    let res = await generateReport(
      startingDate,
      endingDate,
      false
    );

    const dataForReportPage = res.result[0];
    if (dataForReportPage.no_data) {
      this.setState({
        startingDate,
        endingDate,
        changeToNewDates: true,
        isGenerated: true,
        total_actual: 0,
        total_planned: 0,
        dataArray: [],
        loader: false,
      });
      return;
    }
    if (res.ok) {
      this.setState({
        startingDate,
        endingDate,
        changeToNewDates: true,
        isGenerated: true,
      });
      this.createDataForPage(res);
    }
  };

  createDataForPage = (data) => {
    if (data.result && data.result.length) {
      const dataForReportPage = data.result[0]
      this.setState(
        {
          isGenerated: true,
          total_actual: dataForReportPage.total_actual,
          total_planned: dataForReportPage.total_planned,
          loader: false,
          dataArray: [...dataForReportPage.report]
        },
        () => {
          this.initializedCsvData();
        }
      );
    };
  }

  displayNewData = async () => {
    let startingDate = moment(this.state.timestamp.from).format("DD/MM/YYYY");
    let endingDate = moment(this.state.timestamp.to).format("DD/MM/YYYY");
    this.setState(
      {
        startingDate,
        endingDate,
      },
      async () => {
        this.setState({ loader: true });
        let res = await generateReport(
          startingDate,
          endingDate,
          false
        )
        if (res.ok && res.result.is_done) {
          this.createDataForPage(res.result.report);
        } else {
          this.setState({ loader: false });
        }
      }
    );
    this.setState({
      changeToNewDates: true,
    });
  };

  checkExist = async () => {
    let res = await isExistReport();
    return res;
  };

  resetChangeToNewDates = () => {
    this.setState({
      changeToNewDates: false,
    });
  };

  setStartDate = (date) => {
    let startingDate = moment(date);
    this.setState({ startingDate });
  };

  setEndDate = (date) => {
    let endingDate = moment(date);
    this.setState({ endingDate });
  };

  setRange = (timestamp) => {
    this.setState({ timestamp });
  };

  updateDataArray = (new_data_array) => {
    this.setState(
      {
        dataArray: new_data_array,
      },
      () => {
        this.initializedCsvData();
      }
    );
  };

  updateTotalActualValue = (value) => {
    this.setState({ total_actual: value }, () => this.initializedCsvData())
  }

  initializedCsvData = () => {
    const { startingDate, endingDate, reportsPageData } = this.props;
    const { dataArray, total_actual } = this.state;

    const formatDate = (date) => {
      return typeof date === "string"
        ? date
        : moment(date).format("DD/MM/YYYY");
    };

    const csvData = [
      [
        'דו”ח פיננסי לחודש',
        `${formatDate(startingDate)} - ${formatDate(endingDate)}`,
      ],
      [],
      [
        'סה”כ מתוכנן:',
        reportsPageData?.total_planned || 0
      ],
      [
        'יצא:',
        total_actual || 0
      ],
      [],
      ['שם לקוח', 'שלב', 'מתוכנן', 'לחיוב', 'חשבונית', 'קבלה', 'יצא'],
    ];

    (dataArray || []).forEach((item) => {
      csvData.push([
        item.customer_name || '-',
        item.process || '-',
        item.planned || 0,
        item.billable ? 'v' : '',
        item.invoice_issued ? 'v' : '',
        item.payment_received ? 'v' : '',
        item.actual || 0
      ]);
    });

    this.setState({ csvData });
  };

  render() {
    const {
      startingDate,
      endingDate,
      loader,
      csvData,
      changeToNewDates,
      timestamp,
      isGenerated,
    } = this.state;
    const hasValidPrivilege = [FULL_VIEW_ONLY, DEPARTMENT_ONLY, TASK_REMARK_ONLY, TASK_REMARK_QUANTITY_ONLY, ALL_FINANCIALS].some(priv =>
      this.props.login.user.privileges.includes(priv)
    );

    const canCheckUnCheck = this.props.login.user.privileges.length === 0 && [ALL_FINANCIALS].some(priv =>
      this.props.login.user.privileges.includes(priv)
    );
    let reportsPageData = JSON.parse(JSON.stringify(this.state));
    return (
      <div className="reports__container">
        <SideBar />

        <div className="reports-page">
          {loader ? <Loader /> : null}
          <ReportsSideNav
            setStartDate={this.setStartDate}
            setEndDate={this.setEndDate}
            setRange={this.setRange}
            generateReport={this.generateReport}
            csvData={csvData}
            timestamp={timestamp}
            isGenerated={isGenerated}
          />
          {/* {this.props.reportsPageData && this.props.reportsPageData.report &&  */}
          <ReportsPage
            resetChangeToNewDates={this.resetChangeToNewDates}
            changeToNewDates={changeToNewDates}
            updateDataArray={this.updateDataArray}
            startingDate={startingDate}
            endingDate={endingDate}
            reportsPageData={reportsPageData}
            updateTotalActualValue={this.updateTotalActualValue}
            isGenerated={isGenerated}
            isViewOnlyAccess={hasValidPrivilege}
            canCheckUnCheck={canCheckUnCheck}
          />
          {/* } */}
        </div>
      </div>
    );
  }
}


function mapStateToProps({ login }) {
  return { login };
}

function mapDispatchToProps({ }) { }
export default withRouter(connect(mapStateToProps, actions)(MonthlyReports));